import React, { Component } from 'react';
import { formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { ON_HAND_REPORT_LISTING_FORM_NAME } from 'Common/FormEnum';
import { OnHandReportListingEnum } from 'Common/FieldEnum';
import { getIds } from 'Common/FormHelper';
import { PrintGroupByTypeEnum } from 'Common/Constants/Enumeration/CommonEnum';
import * as FilterSelectors from 'State/filters/selectors';

import OnHandReportListingComponent from '../../components/OnHandReportListing';
import { INITIAL_VALUES } from '../../helper/listing';
import { getOnHandItems } from '../../state/actions';
import * as OnHandListingSelectors from '../../state/selectors';
import * as CommonPrintSelector from '../../../commonState/selectors';

class OnHandReportListing extends Component {
  static propTypes = {
    getOnHandItems: PropTypes.func.isRequired,
    bidGroupData: PropTypes.array.isRequired,
    itemGroupData: PropTypes.array.isRequired,
    acctCategoryData: PropTypes.array.isRequired,
    vendorData: PropTypes.array.isRequired,
    onHandItems: PropTypes.array.isRequired,
    allSitesData: PropTypes.array.isRequired,
    initialValues: PropTypes.object.isRequired,
    onSubmit: PropTypes.func,
    handleClickPrint: PropTypes.func,
    printOptionsValue: PropTypes.number,
    SiteIds: PropTypes.array,
    loadingOnHandItems: PropTypes.bool,
    loadingPrint: PropTypes.bool,
    siteReactTableRef: PropTypes.object,
    itemReactTableRef: PropTypes.object,
  };

  static defaultProps = {
    printOptionsValue: PrintGroupByTypeEnum.Item,
    SiteIds: [],
    loadingOnHandItems: false,
    loadingPrint: false,
    onSubmit: () => {},
    handleClickPrint: () => {},
    siteReactTableRef: null,
    itemReactTableRef: null,
  };

  state = {
    activeIndexes: [0, 1],
    filterValues: INITIAL_VALUES,
  };
  itemGridInstance = null;
  siteGridInstance = null;

  handleCollapsePanelClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndexes } = this.state;
    const activeIndexesClone = [...this.state.activeIndexes];
    activeIndexes.indexOf(index) !== -1
      ? activeIndexesClone.splice(activeIndexes.indexOf(index), 1)
      : activeIndexesClone.push(index);
    this.setState({ activeIndexes: activeIndexesClone });
  };

  handleChange = (e, values) => {
    const valuesCopy = { ...values };
    delete valuesCopy[OnHandReportListingEnum.ItemIds];
    const { SiteIds, getOnHandItems, change } = this.props;
    this.setState({ filterValues: values }, () => {
      change(OnHandReportListingEnum.ItemIds, []);
      getOnHandItems({
        ...valuesCopy,
        SiteIds,
      });
    });
  };

  clearFilters = () => {
    const { change, getOnHandItems, printOptionsValue, reset } = this.props;
    const printValue = printOptionsValue;
    reset();
    const Ids = getIds(this.props.allSitesData);
    change(OnHandReportListingEnum.SiteIds, Ids);
    change(OnHandReportListingEnum.PrintOptions, printValue);
    const values = { ...INITIAL_VALUES };
    delete values.SiteIds;
    delete values.PrintOptions;
    this.setState(
      {
        filterValues: values,
      },
      () => {
        const values = { ...this.state.filterValues };
        delete values[OnHandReportListingEnum.ItemIds];
        getOnHandItems({
          ...values,
          [OnHandReportListingEnum.SiteIds]: Ids,
        });
      }
    );
    this.itemGridInstance && this.itemGridInstance.clearTableState();
    this.siteGridInstance && this.siteGridInstance.clearTableState();
  };
  setItemGridInstance = ref => {
    this.itemGridInstance = ref;
  };
  setSiteGridInstance = ref => {
    this.siteGridInstance = ref;
  };

  render() {
    const {
      printOptionsValue,
      onHandItems,
      loadingOnHandItems,
      loadingAllSites,
      bidGroupData,
      itemGroupData,
      acctCategoryData,
      vendorData,
      loadingPrint,
      handleClickPrint,
      siteReactTableRef,
      itemReactTableRef,
      printLoading,
    } = this.props;

    return (
      <OnHandReportListingComponent
        handleChange={this.handleChange}
        filterValues={this.state.filterValues}
        clearFilters={this.clearFilters}
        handleCollapsePanelClick={this.handleCollapsePanelClick}
        activeIndexes={this.state.activeIndexes}
        printOptionsValue={printOptionsValue}
        onHandItems={onHandItems}
        loadingOnHandItems={loadingOnHandItems}
        loadingAllSites={loadingAllSites}
        bidGroupData={bidGroupData}
        itemGroupData={itemGroupData}
        acctCategoryData={acctCategoryData}
        vendorData={vendorData}
        loadingPrint={loadingPrint}
        handleClickPrint={handleClickPrint}
        setItemGridInstance={this.setItemGridInstance}
        setSiteGridInstance={this.setSiteGridInstance}
        siteReactTableRef={siteReactTableRef}
        itemReactTableRef={itemReactTableRef}
        printLoading={printLoading}
      />
    );
  }
}

OnHandReportListing = reduxForm({
  form: ON_HAND_REPORT_LISTING_FORM_NAME,
  destroyOnUnmount: false,
})(OnHandReportListing);

const selector = formValueSelector(ON_HAND_REPORT_LISTING_FORM_NAME);
const mapStateToProps = state => {
  return {
    printOptionsValue: selector(state, [OnHandReportListingEnum.PrintOptions]),
    SiteIds: selector(state, [OnHandReportListingEnum.SiteIds]),
    bidGroupData: FilterSelectors.selectBidGroupData(state),
    itemGroupData: FilterSelectors.selectItemGroupData(state),
    acctCategoryData: FilterSelectors.selectAcctCategoryData(state),
    vendorData: FilterSelectors.selectVendorData(state),
    onHandItems: OnHandListingSelectors.getOnHandItems(state),
    loadingOnHandItems: OnHandListingSelectors.getLoadingOnHandItems(state),
    allSitesData: OnHandListingSelectors.getAllSitesData(state),
    printLoading: CommonPrintSelector.getPrintLoading(state),
  };
};

const mapDispatchToProps = {
  getOnHandItems,
};
export const OnHandReportListingContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(OnHandReportListing);



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/onhandreport/containers/onhandreportlisting/OnHandReportListing.js